<template>
  <div>
    <div
      v-if="fetchInProgress"
      class="h-24 w-48 flex justify-center items-center"
    >
      <Spinner class="text-yellow-400" />
    </div>
    <template v-else>
      <EventEditorProgramFieldItem
        v-if="program"
        :program="program"
        selected
        class="my-2"
      />
      <div
        v-else
        class="rounded border text-sm w-full flex flex-col py-3 px-3 text-gray-200"
      >
        No program selected
      </div>
      <TextButton class="ml-1" @click="openDialog()">
        {{ program ? 'Change' : 'Set' }} program
      </TextButton>
      <TextButton class="ml-3" v-if="program" @click="clearProgram()">
        Clear program
      </TextButton>
      <el-dialog title="Choose program" :visible.sync="isDialogOpen">
        <div class="space-y-4">
          <EventEditorProgramFieldItem
            v-for="p in programs"
            :key="p.id"
            :program="p"
            @click="chooseProgram(p.id)"
            :selected="program && p.id === program.id"
          />
        </div>
      </el-dialog>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TextButton from 'components/common/TextButton.vue'
import Button from 'components/common/Button.vue'
import EventEditorProgramFieldItem from './EventEditorProgramFieldItem.vue'
import Spinner from '../../components/common/Spinner.vue'
import orderBy from 'lodash/orderBy'

export default {
  components: {
    TextButton,
    Button,
    EventEditorProgramFieldItem,
    Spinner,
  },
  props: {
    orgId: { type: String },
    showroomId: { type: String },
    value: { type: String, required: false },
  },
  data() {
    return {
      isDialogOpen: false,
    }
  },
  computed: {
    ...mapState({
      allPrograms: (state) => state.organizationProgramList.programs,
      fetchInProgress: (state) => state.organizationProgramList.fetchInProgress,
    }),
    programs() {
      return orderBy(this.allPrograms, ['created_at'], ['desc'])
    },
    program() {
      if (this.$props.value) {
        return this.programs.filter((p) => p.id === this.$props.value)[0]
      } else {
        return null
      }
    },
  },
  created() {
    console.log(' => fetch programs | this.orgId:', this.orgId)
    this.fetchPrograms()
  },
  methods: {
    onChange(choice) {
      this.$emit('change', choice)
    },
    fetchPrograms() {
      this.$store.dispatch('organizationProgramList/fetch', {
        organizationId: this.orgId,
      })
    },
    openDialog() {
      this.isDialogOpen = true
    },
    closeDialog() {
      this.isDialogOpen = false
    },
    chooseProgram(programId) {
      this.$emit('update', programId)
      this.$store.dispatch('organizationProgramDetails/fetch', {
        organizationId: this.orgId,
        programId,
      })
    },
    clearProgram() {
      this.$emit('update', null)
    },
  },
}
</script>
